import {
  RETURNS_AUTOMATIONS_PROCESSING_SETTINGS_PATH,
  RETURNS_AUTOMATIONS_SETTINGS_PATH,
  RETURNS_WAREHOUSE_SETTINGS_PATH,
} from "./settings-paths";

export enum ReturnsSettingsTab {
  COVERAGE = "coverage",
  POLICIES = "policies",
  PORTAL = "portal",
  OPERATIONS = "operations",
  LABELS = "labels",
  LOCATIONS = "locations",
  SHOPPER_NOTIFICATIONS = "shopper-notifications",
  WAREHOUSE = "warehouse",
}

export const RETURNS_SETTINGS_TAB_QUERY_PARAM = "tab";

export function isReturnsSettingsTab(
  value: string | null,
): value is ReturnsSettingsTab {
  return Object.values<string>(ReturnsSettingsTab).includes(value ?? "");
}

/** Old pages the returns page replaced, with the tab each one opens. */
export const RETURNS_SETTINGS_TAB_BY_LEGACY_PATH: Readonly<
  Record<string, ReturnsSettingsTab>
> = {
  [RETURNS_AUTOMATIONS_SETTINGS_PATH]: ReturnsSettingsTab.OPERATIONS,
  [RETURNS_AUTOMATIONS_PROCESSING_SETTINGS_PATH]: ReturnsSettingsTab.OPERATIONS,
  coverage: ReturnsSettingsTab.COVERAGE,
  "customer-portal": ReturnsSettingsTab.PORTAL,
  exchanges: ReturnsSettingsTab.OPERATIONS,
  processing: ReturnsSettingsTab.OPERATIONS,
  "returns-ui": ReturnsSettingsTab.WAREHOUSE,
  shipping: ReturnsSettingsTab.LABELS,
  [RETURNS_WAREHOUSE_SETTINGS_PATH]: ReturnsSettingsTab.WAREHOUSE,
};
